<template>
  <div class="page main-signin-wrapper bg-signin">
    <div class="row signpages text-center">
      <div class="col-md-12 my-auto">
        <div class="card">
          <div class="row row-sm m-0">
            <!-- Panel izquierdo: logo (solo pantallas >= lg) -->
            <div class="col-lg-6 col-xl-5 d-none d-lg-block text-center details">
              <div class="position-absolute top-50 start-50 translate-middle logo-wrap">
                <img
                  :src="require('@/assets/img/pages/authentication/desktop-white.png')"
                  class="header-brand-img mw-40"
                  alt="logo"
                >
              </div>
            </div>

            <!-- Panel derecho: formulario -->
            <div class="col-lg-6 col-xl-7 col-xs-12 col-sm-12 login_form">
              <div class="main-container container-fluid">
                <div class="row row-sm">
                  <div class="card-body mt-2 mb-2">
                    <form @submit.prevent="formSubmit">
                      <h5 class="text-start mb-2">
                        Iniciar sesión en su cuenta
                      </h5>
                      <p class="mb-4 text-muted fs-13 ms-0 text-start">
                        Flux Solar Inspector, la plataforma de inspecciones en terreno de CopecFlux
                      </p>

                      <!-- Modo credenciales -->
                      <template v-if="!showGoogleLogin">
                        <div class="form-group text-start">
                          <label for="loginEmail">Correo</label>
                          <input
                            id="loginEmail"
                            v-model="form.email"
                            name="email"
                            class="form-control"
                            placeholder="Introduce tu correo"
                            type="email"
                            :class="{ 'is-invalid': $v.form.email.$error }"
                          >
                          <div
                            v-if="$v.form.email.$error"
                            class="invalid-feedback d-block"
                          >
                            <span
                              v-if="!$v.form.email.required"
                            >Correo electrónico es requerido.</span>
                            <span
                              v-else-if="!$v.form.email.email"
                            >Ingresa un correo electrónico valido.</span>
                          </div>
                        </div>

                        <div class="form-group text-start">
                          <label for="loginPassword">Contraseña</label>
                          <input
                            id="loginPassword"
                            v-model="form.password"
                            name="password"
                            class="form-control"
                            placeholder="Ingresa tu contraseña"
                            :type="showPassword ? 'text' : 'password'"
                            :class="{ 'is-invalid': $v.form.password.$error }"
                          >
                          <div
                            v-if="$v.form.password.$error"
                            class="invalid-feedback d-block"
                          >
                            <span
                              v-if="!$v.form.password.required"
                            >Contraseña es requerida.</span>
                          </div>

                          <div class="d-flex align-items-center mt-1">
                            <input
                              id="showPassword"
                              v-model="showPassword"
                              type="checkbox"
                              class="form-check-input"
                            >
                            <label
                              for="showPassword"
                              class="form-check-label text-muted ms-1"
                            >
                              Mostrar contraseña
                            </label>
                          </div>
                        </div>
                      </template>

                      <div class="d-flex">
                        <!-- Modo social -->
                        <template v-if="showGoogleLogin">
                          <div class="d-flex flex-column gap-3 mb-4 w-100">
                            <button
                              type="button"
                              class="btn ripple bg-primary-transparent d-flex align-items-center justify-content-center w-100"
                              @click="loginWithGoogle"
                            >
                              <span class="avatar avatar-sm rounded-2 p-1 bg-white me-2">
                                <img
                                  :src="require('@/assets/img/pages/authentication/google.png')"
                                  alt="google-logo"
                                >
                              </span>
                              Inicia sesión con Google
                            </button>
                          </div>
                        </template>

                        <!-- Botón credenciales -->
                        <button
                          v-else
                          type="submit"
                          class="btn ripple btn-primary me-3"
                          :disabled="processing"
                        >
                          <b-spinner
                            v-if="processing"
                            small
                            type="grow"
                            class="mr-2"
                          />
                          Iniciar sesión
                        </button>
                      </div>
                    </form>

                    <!-- Toggle de modo y recuperación de contraseña -->
                    <div class="text-start mt-4 ms-0">
                      <div class="mb-1 d-flex justify-content-between flex-wrap">
                        <a
                          href="javascript:void(0);"
                          class="header-link"
                          @click="showGoogleLogin = !showGoogleLogin"
                        >
                          {{
                            showGoogleLogin
                              ? 'Iniciar sesión con Credenciales'
                              : 'Inicia sesión con Google'
                          }}
                        </a>

                        <router-link
                          v-if="!showGoogleLogin"
                          :to="{ name: 'forgot-password' }"
                          class="header-link forgot-link"
                        >
                          ¿Olvidaste tu contraseña?
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mapGetters, mapActions } from 'vuex'
import { PARAMS_LOGIN_GOOGLE, GOOGLE_AUTH_URL } from '@/constants/google'
import {
  GOOGLE_PKCE_VERIFIER_STORAGE_KEY,
  createPkceVerifier,
  createPkceChallenge,
} from '@/utils/pkce'

const { required, minLength, email } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      showGoogleLogin: true,
      showPassword: false,
    }
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(4),
      },
      email: {
        required,
        email,
        minLength: minLength(4),
      },
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
      processing: 'auth/processing',
      loginError: 'auth/loginError',
    }),
  },
  watch: {
    currentUser: {
      immediate: true,
      handler(val) {
        if (val && val.email) {
          setTimeout(() => {
            this.$router.push({ name: 'my-checklists-pending' })
          }, 200)
        }
      },
    },
    loginError: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val != null) {
          console.log(val)
        }
      },
    },
  },
  methods: {
    ...mapActions({ login: 'auth/login' }),
    async formSubmit() {
      this.$v.$touch()
      this.$v.form.$touch()
      if (!this.$v.form.$anyError) {
        const response = await this.login({
          email: this.form.email,
          password: this.form.password,
        })
        if (response?.data?.error) {
          this.$bvToast.toast('Correo o Contraseña invalidos', {
            title: 'Error',
            variant: 'danger',
            solid: false,
          })
        }
      }
    },
    async loginWithGoogle() {
      try {
        const codeVerifier = createPkceVerifier()
        const codeChallenge = await createPkceChallenge(codeVerifier)

        sessionStorage.setItem(GOOGLE_PKCE_VERIFIER_STORAGE_KEY, codeVerifier)

        const urlParams = new URLSearchParams({
          ...PARAMS_LOGIN_GOOGLE,
          code_challenge: codeChallenge,
          code_challenge_method: 'S256',
        }).toString()

        window.location = `${GOOGLE_AUTH_URL}?${urlParams}`
      } catch (error) {
        this.$bvToast.toast(
          'No fue posible iniciar sesion con Google, intentalo nuevamente',
          {
            title: 'Error',
            variant: 'danger',
            solid: false,
          },
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$primary-prod: rgb(20, 108, 253);
$primary-prod-soft: rgba(20, 108, 253, 0.1);
$border-prod: #e9edf6;
$card-border-prod: #e8e8f7;
$muted-prod: #8f8fb1;
$text-prod: #1d212f;

/* Utilidades de Bootstrap 5 / tema Link que no existen en Bootstrap 4 */
.text-start {
  text-align: left !important;
}

.fs-13 {
  font-size: 0.8125rem !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 4px !important;
}

.me-2 {
  margin-right: 8px !important;
}

.me-3 {
  margin-right: 16px !important;
}

.gap-3 {
  gap: 1rem !important;
}

/* La escala de espaciado del tema de Inspector difiere de Bootstrap 5 de Link */
.mb-4 {
  margin-bottom: 24px !important;
}

.mt-4 {
  margin-top: 24px !important;
}

.rounded-2 {
  border-radius: 6px !important;
}

.text-muted {
  color: $muted-prod !important;
}

.top-50 {
  top: 50% !important;
}

.start-50 {
  left: 50% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.page.main-signin-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Gotham Rounded Light', 'sans-serif';

  .signpages {
    border-radius: 6px;
    width: 50%;
    margin: 5em auto;
    display: flex;

    @media (max-width: 1299.98px) {
      width: 60%;
    }

    @media (max-width: 640px) {
      width: 90%;
    }

    > .col-md-12 {
      padding-left: 12px;
      padding-right: 12px;
    }

    .card {
      width: 100%;
      border: 1px solid $card-border-prod;
      border-radius: 6px;
      background-color: #fff;
      box-shadow: none;

      .row.row-sm {
        margin-left: -10px;
        margin-right: -10px;

        > [class*='col-'] {
          padding-left: 10px !important;
          padding-right: 10px !important;
        }
      }

      .details {
        position: relative;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        background-color: $primary-prod;
        overflow: hidden;

        .logo-wrap {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .header-brand-img {
          width: 100%;
          max-width: 100%;
          height: auto;
        }
      }

      .login_form {
        background-color: #fff;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;

        .main-container {
          width: 100%;
          padding: 0 12px;
        }

        .card-body {
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 1.5rem 10px;
        }

        h5 {
          font-size: 17.5px;
  font-weight: 500;
  font-family: 'Gotham Rounded Light', 'sans-serif';
  line-height: 1.2;
  color: $text-prod;
  margin-bottom: 8px;
  text-align: left;
}

        p {
          font-size: 13px;
          line-height: 1.5;
          color: $muted-prod;
          margin-bottom: 24px;
          text-align: left;
        }

        .form-group {
          margin-bottom: 16px;
          text-align: left;

          label {
            font-size: 14px;
            color: $text-prod;
            margin-bottom: 0;
          }

          .form-control {
            height: 38.5px;
            padding: 6px 12px;
            font-size: 14px;
            line-height: 1.75;
            color: $muted-prod;
            background-color: #fff;
            border: 1px solid $border-prod;
            border-radius: 5.6px;

            &:focus {
              color: $text-prod;
              border-color: #86b7fe;
              box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
            }

            &::placeholder {
              color: $muted-prod;
            }
          }

          .form-check-input {
            position: static;
            width: 14.4px;
            height: 14.4px;
            margin: 0;
            border: 1px solid $border-prod;
            border-radius: 3.5px;
            background-color: #fff;
            -webkit-appearance: none;
            appearance: none;

            &:checked {
              background-color: #0d6efd;
              border-color: #0d6efd;
            }
          }

          .form-check-label {
            font-size: 14px;
            color: $muted-prod;
            margin-left: 4px;
            margin-bottom: 0;
          }
        }

        .ripple {
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .bg-primary-transparent {
          height: 40px;
          padding: 8px 13.6px;
          font-size: 13.6px;
          font-weight: 400;
          line-height: 20.4px;
          gap: 6px;
          background-color: $primary-prod-soft !important;
          color: $primary-prod !important;
          border: 1px solid transparent;
          border-radius: 3px;

          .avatar {
            width: 32px;
            height: 32px;
            padding: 4px;
            margin-right: 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            border-radius: 6px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 6px;
            }
          }
        }

        .btn-primary {
          height: 40px;
          padding: 8px 13.6px;
          font-size: 13.6px;
          line-height: 20.4px;
          background-color: $primary-prod !important;
          border-color: $primary-prod !important;
          color: #fff !important;
          border-radius: 3px;

          &:hover:not(:disabled) {
            background-color: rgba(20, 108, 253, 0.9) !important;
            border-color: $primary-prod !important;
          }
        }

        a {
          color: $primary-prod;
        }

        .header-link {
          display: inline-block;
          font-size: 14px;
          color: $primary-prod;
          text-decoration: none;
          cursor: pointer;
        }
      }
    }
  }
}

.bg-signin {
  background-image: url("~@/assets/img/pages/authentication/background-signin.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
</style>

<style lang="scss">
@font-face {
  font-family: 'Gotham Rounded Light';
  src: url('~@/assets/fonts/Gotham_Rounded_Light.otf') format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Gotham Rounded Bold';
  src: url('~@/assets/fonts/Gotham_Rounded_Bold.otf') format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
</style>
